export default __webpack_public_path__ + "static/pturner-0f6a45dbc2623fba76875a86629d43e9.jpg";